import BasketFill from './BasketFill';

export default BasketFill;
